define (function (require) {
    const processManager = require('civicsUtils/process_manager/process_manager');

    return {
        /* If we are using SSO, we should check for a Redirect page in the session storage.  
        Otherwise redirect to My Dashboard. */
        processSSOLoginRedirect: function(view) {
            if (view.config.usesSSO) {
				let returnLinks = view.getReturnLinks();
				let activeProcess = processManager.hasActiveProcess();
				if (returnLinks.length == 1) {
					var redirectPage = App.sessionStorage.get('CIVICS', 'REDIRECT');
					if (redirectPage && redirectPage != "/" && redirectPage != view.config.HomePage) {      //Don't go home.
						App.sessionStorage.remove('CIVICS', 'REDIRECT');
						window.location.assign(redirectPage);
					} else {
						if (activeProcess) {
							let processReturnUrl = processManager.getReturnURL();
							if (processReturnUrl) {
								window.location.assign(processReturnUrl);
								return;
							}
						}
						if (__DEV__) console.log("Redirecting to: " + view.config.DashboardTargetPage);
						window.location.assign(view.config.DashboardTargetPage);
					}
				} 	
			}

            // TO-DO
            // If we are using SSO and Activation, then we need to logout user and send message that they need to activate to login via session storage.
        }
    }
})